<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Lista de FollowUp'" :showBtn="true" :btnName="'Cadastrar FollowUp'"
                   :btnRoute="'/cadastro-followup'" :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- No Result -->
            <div v-if="!loadingList && (dataList !== '' && !dataList.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhum followUp encontrado.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Tivemos um problema com a conexão. Tente novamente atualizando a página.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataList.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total de followUp ({{ dataList.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> ID</th>
                        <th> TÍTULO</th>
                        <th> DE QUEM FOI ENVIADO</th>
                        <th> PLANO</th>
                        <th> QTD DIAS CADASTRADO</th>
                        <th> MIN FUN</th>
                        <th> MAX FUN</th>
                        <th> ATIVO</th>
                        <th> DATA CADASTRO</th>
                        <th> AÇÕES</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataList">
                        <td>#{{ c.id }}</td>
                        <td>{{ c.title }}</td>
                        <td>{{ c.fromWhoEmail }}</td>
                        <td>{{ c.plan }}</td>
                        <td>{{ c.companyDaysCreated }}</td>
                        <td>{{ c.minEmployee }}</td>
                        <td>{{ c.maxEmployee }}</td>
                        <td>
                          <span v-if="c.isActive">SIM</span>
                          <span v-else>NÃO</span>
                        </td>
                        <td>{{ c.createdAt | formatFullDate }}</td>
                        <td>
                          <a v-bind:href="'/editar-followup/' + c.id" title="Editar" class="btn-to-edit">
                            <i class="fa fa-pencil" aria-hidden="true"></i> Editar
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";

import {
  DELETE_CODE,
  GET_ALL_FUP
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import swal from "sweetalert";

export default {
  name: "follow-up",
  components: {
    topMenu,
    pageHeader,
    fullLoading
  },
  data() {
    return {
      loadingList: false,
      failRequest: false,
      dataList: ''
    }
  },
  methods: {
    getList() {
      this.loadingList = true;
      this.failRequest = false;

      REQUEST_SERVICE.get(GET_ALL_FUP).then((response) => {
        UTIL_SERVICE.console("RESULT GET_ALL_FUP:", response.data);

        this.dataList = response.data;
        this.loadingList = false;
      }).catch((reason) => {
        this.failRequest = true;
        this.loadingList = false;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/allCompany/followUp.vue